import React, { useEffect, useState } from "react";
import { Title, Button } from "rbx";
import PropTypes from "prop-types";
import { Typography } from "@mui/material";
import FollowupSection from "./components/FollowupSection/FollowupSection";
import FollowupForm from "./components/FollowupForm/FollowupForm";
import { useModal, useAuth } from "../../context";
import { usePermissions } from "../../hooks";
import capitalizeEveryWord from "../../utils/capitalizeEveryWord";
import "./Followups.scss";

import checkMobile from "../../utils/checkForMobile";

const IncompleteFollowups = ({
  followups,
  employeeNumber,
  loading,
  setFollowups,
  refetchMyFollowups,
  userData,
  handleOpenFollowupAdd,
}) => {
  const permissionLevels = usePermissions();
  const isMobile = checkMobile();
  const [permissions, setPermissions] = useState(null);

  const auth = useAuth();
  const activeUserEmployeeNumber = auth?.state?.user?.employeeNumber;

  const isUsersOwnFollowups =
    activeUserEmployeeNumber.trim() === employeeNumber.trim();

  const showManagerReviews =
    permissions?.webEditor ||
    permissions?.superAdmin ||
    permissions?.admin ||
    permissions?.fieldSupervisor;

  const { setModalOpen } = useModal();

  const handleComplete = async () => {
    setModalOpen(false);
    await refetchMyFollowups();
  };

  const incompleteFollowups = followups.filter((followup) => followup.status === "Active");

  useEffect(() => {
    if (permissionLevels) {
      setPermissions(permissionLevels);
    }
  }, [permissionLevels]);

  const handleOpenFollowup = (
    followup,
    followupIndex,
    isCompletedSection,
    type = "view"
  ) => {
    setModalOpen(
      true,
      <FollowupForm
        currentFollowupId={followup?.id}
        employeeNumber={employeeNumber}
        followup={followup}
        followups={followups}
        isCompletedSection={isCompletedSection}
        loading={loading}
        permissions={permissionLevels}
        refetchMyFollowups={refetchMyFollowups}
        type={type}
        onCanceled={() => setModalOpen(false)}
        onComplete={handleComplete}
      />
    );
  };

  return (
    <div
      className={
        showManagerReviews
          ? "reviews-outer-container-manager-followups"
          : "reviews-outer-container-followups"
      }
    >
      <div className="reviews-container-section">
        <div className="reviews">
          {!isUsersOwnFollowups && (
            <div className="add-button-container">
              <Button
                className="review-option-primary"
                style={{ marginBottom: "1.5rem", padding: "0.5rem" }}
                type="button"
                onClick={() => handleOpenFollowupAdd()}
              >
                <Title size={6} textColor="white">
                  Add Follow-up
                </Title>
              </Button>
            </div>
          )}
          {incompleteFollowups.length ? (
            <React.Fragment>
              <div className="centered-title" id="employee-reviews">
                <Typography variant={isMobile ? "h4" : "h3"}>
                  {capitalizeEveryWord(
                    `${userData?.firstName} ${userData?.lastName} Active Follow-ups`
                  )}
                </Typography>
              </div>
              <FollowupSection
                followups={followups}
                handleClick={handleOpenFollowup}
                handleOpenFollowupAdd={handleOpenFollowupAdd}
                isUsersOwnFollowups={isUsersOwnFollowups}
                sectionType="personal"
                setFollowups={setFollowups}
                showManagerReviews={showManagerReviews}
              />
            </React.Fragment>
          ) : (
            <div className="centered-title">
              <Typography variant={isMobile ? "h4" : "h3"}>
                Nice! All your follow-ups are completed
              </Typography>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

IncompleteFollowups.propTypes = {
  followups: PropTypes.array.isRequired,
  employeeNumber: PropTypes.string.isRequired,
  loading: PropTypes.bool.isRequired,
  setFollowups: PropTypes.func.isRequired,
  refetchMyFollowups: PropTypes.func,
  userData: PropTypes.object.isRequired,
  handleOpenFollowupAdd: PropTypes.func.isRequired,
};

IncompleteFollowups.defaultProps = {
  refetchMyFollowups: () => {},
};

export default IncompleteFollowups; 